var _path, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path2, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChartLoading(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1038,
    height: 189,
    viewBox: "0 0 1038 189",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H1038V189H0V0Z",
    fill: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 159.5,
    x2: 1016.27,
    y2: 159.5,
    stroke: "#E6E6E6"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 129.5,
    x2: 1016.27,
    y2: 129.5,
    stroke: "#E6E6E6"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 99.5,
    x2: 1016.27,
    y2: 99.4999,
    stroke: "#E6E6E6"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 69.5,
    x2: 1016.27,
    y2: 69.4999,
    stroke: "#E6E6E6"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 39.5,
    x2: 1016.27,
    y2: 39.4999,
    stroke: "#E6E6E6"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 56,
    y1: 9.5,
    x2: 1016.27,
    y2: 9.49992,
    stroke: "#E6E6E6"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 77.5,
    y1: 10,
    x2: 77.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 161.5,
    y1: 10,
    x2: 161.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 246.5,
    y1: 10,
    x2: 246.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 331.5,
    y1: 10,
    x2: 331.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 416.5,
    y1: 10,
    x2: 416.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 501.5,
    y1: 10,
    x2: 501.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 584.5,
    y1: 10,
    x2: 584.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 667.5,
    y1: 10,
    x2: 667.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 753.5,
    y1: 10,
    x2: 753.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 838.5,
    y1: 10,
    x2: 838.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 922.5,
    y1: 10,
    x2: 922.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 1008.5,
    y1: 10,
    x2: 1008.5,
    y2: 159,
    stroke: "#E6E6E6",
    strokeDasharray: "4 4"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 12,
    rx: 2,
    fill: "url(#paint0_linear_3526_3480)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 33,
    width: 40,
    height: 12,
    rx: 2,
    fill: "url(#paint1_linear_3526_3480)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 64,
    width: 40,
    height: 12,
    rx: 2,
    fill: "url(#paint2_linear_3526_3480)"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 93,
    width: 40,
    height: 12,
    rx: 2,
    fill: "url(#paint3_linear_3526_3480)"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 124,
    width: 40,
    height: 12,
    rx: 2,
    fill: "url(#paint4_linear_3526_3480)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 153,
    width: 40,
    height: 12,
    rx: 2,
    fill: "url(#paint5_linear_3526_3480)"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 169,
    width: 974,
    height: 12,
    rx: 2,
    fill: "url(#paint6_linear_3526_3480)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M478.159 88.35H486.475V90H476.399V75.48H478.159V88.35ZM493.45 78.78C494.491 78.78 495.408 79.0073 496.2 79.462C497.006 79.9167 497.637 80.5767 498.092 81.442C498.546 82.2927 498.774 83.312 498.774 84.5C498.774 85.688 498.546 86.7147 498.092 87.58C497.637 88.4307 497.006 89.0833 496.2 89.538C495.408 89.9927 494.491 90.22 493.45 90.22C492.423 90.22 491.506 89.9927 490.7 89.538C489.893 89.0833 489.262 88.4307 488.808 87.58C488.353 86.7147 488.126 85.688 488.126 84.5C488.126 83.312 488.353 82.2927 488.808 81.442C489.262 80.5767 489.893 79.9167 490.7 79.462C491.506 79.0073 492.423 78.78 493.45 78.78ZM493.45 80.298C492.702 80.298 492.064 80.4667 491.536 80.804C491.008 81.1413 490.597 81.6253 490.304 82.256C490.025 82.872 489.886 83.62 489.886 84.5C489.886 85.3653 490.025 86.1133 490.304 86.744C490.597 87.3747 491.008 87.8587 491.536 88.196C492.064 88.5333 492.702 88.702 493.45 88.702C494.198 88.702 494.836 88.5333 495.364 88.196C495.892 87.8587 496.295 87.3747 496.574 86.744C496.867 86.1133 497.014 85.3653 497.014 84.5C497.014 83.62 496.867 82.872 496.574 82.256C496.295 81.6253 495.892 81.1413 495.364 80.804C494.836 80.4667 494.198 80.298 493.45 80.298ZM508.511 82.894C508.511 82.0727 508.291 81.442 507.851 81.002C507.411 80.5473 506.788 80.32 505.981 80.32C505.218 80.32 504.573 80.4887 504.045 80.826C503.517 81.1487 503.128 81.6767 502.879 82.41L501.449 81.53C501.742 80.7087 502.285 80.0487 503.077 79.55C503.869 79.0367 504.852 78.78 506.025 78.78C506.817 78.78 507.536 78.9193 508.181 79.198C508.826 79.462 509.332 79.8727 509.699 80.43C510.08 80.9727 510.271 81.6767 510.271 82.542V87.866C510.271 88.394 510.55 88.658 511.107 88.658C511.386 88.658 511.657 88.6213 511.921 88.548L511.833 89.934C511.54 90.0807 511.158 90.154 510.689 90.154C510.264 90.154 509.882 90.0733 509.545 89.912C509.208 89.7507 508.944 89.5087 508.753 89.186C508.562 88.8487 508.467 88.4307 508.467 87.932V87.712L508.907 87.778C508.731 88.35 508.43 88.8193 508.005 89.186C507.58 89.538 507.103 89.802 506.575 89.978C506.047 90.1393 505.526 90.22 505.013 90.22C504.368 90.22 503.766 90.11 503.209 89.89C502.652 89.67 502.204 89.34 501.867 88.9C501.544 88.4453 501.383 87.888 501.383 87.228C501.383 86.4067 501.654 85.732 502.197 85.204C502.754 84.6613 503.524 84.2947 504.507 84.104L508.863 83.246V84.698L505.321 85.424C504.602 85.5707 504.067 85.776 503.715 86.04C503.363 86.304 503.187 86.6707 503.187 87.14C503.187 87.5947 503.363 87.9687 503.715 88.262C504.082 88.5407 504.595 88.68 505.255 88.68C505.68 88.68 506.084 88.6287 506.465 88.526C506.861 88.4087 507.213 88.24 507.521 88.02C507.829 87.7853 508.071 87.4993 508.247 87.162C508.423 86.81 508.511 86.3993 508.511 85.93V82.894ZM518.838 90.22C517.929 90.22 517.093 89.9927 516.33 89.538C515.567 89.0833 514.959 88.4307 514.504 87.58C514.049 86.7147 513.822 85.688 513.822 84.5C513.822 83.2827 514.064 82.2487 514.548 81.398C515.032 80.5473 515.67 79.902 516.462 79.462C517.254 79.0073 518.105 78.78 519.014 78.78C519.923 78.78 520.708 79.0147 521.368 79.484C522.043 79.9533 522.49 80.5767 522.71 81.354L522.49 81.508V73.94H524.25V90H522.71L522.556 87.338L522.798 87.206C522.695 87.8513 522.446 88.4013 522.05 88.856C521.669 89.296 521.192 89.6333 520.62 89.868C520.063 90.1027 519.469 90.22 518.838 90.22ZM519.014 88.68C519.718 88.68 520.327 88.504 520.84 88.152C521.368 87.8 521.771 87.3013 522.05 86.656C522.343 85.996 522.49 85.226 522.49 84.346C522.49 83.51 522.343 82.7913 522.05 82.19C521.771 81.5887 521.375 81.1267 520.862 80.804C520.363 80.4813 519.777 80.32 519.102 80.32C517.987 80.32 517.122 80.7013 516.506 81.464C515.89 82.2267 515.582 83.2387 515.582 84.5C515.582 85.7613 515.883 86.7733 516.484 87.536C517.085 88.2987 517.929 88.68 519.014 88.68ZM529.221 76.888C528.825 76.888 528.502 76.7707 528.253 76.536C528.018 76.2867 527.901 75.964 527.901 75.568C527.901 75.172 528.018 74.8567 528.253 74.622C528.502 74.3727 528.825 74.248 529.221 74.248C529.617 74.248 529.932 74.3727 530.167 74.622C530.416 74.8567 530.541 75.172 530.541 75.568C530.541 75.964 530.416 76.2867 530.167 76.536C529.932 76.7707 529.617 76.888 529.221 76.888ZM530.101 79V90H528.341V79H530.101ZM534.185 90V79H535.725L535.879 81.464L535.593 81.222C535.827 80.6353 536.143 80.166 536.539 79.814C536.935 79.4473 537.389 79.1833 537.903 79.022C538.431 78.8607 538.973 78.78 539.531 78.78C540.323 78.78 541.041 78.934 541.687 79.242C542.332 79.5353 542.845 79.99 543.227 80.606C543.623 81.222 543.821 82.0067 543.821 82.96V90H542.061V83.576C542.061 82.3587 541.797 81.5153 541.269 81.046C540.755 80.562 540.117 80.32 539.355 80.32C538.827 80.32 538.299 80.4447 537.771 80.694C537.243 80.9433 536.803 81.3467 536.451 81.904C536.113 82.4613 535.945 83.2093 535.945 84.148V90H534.185ZM557.068 76.976L557.464 78.538C557.449 78.538 557.427 78.538 557.398 78.538C557.368 78.538 557.339 78.538 557.31 78.538C556.591 78.538 556.034 78.6847 555.638 78.978C555.256 79.2567 555.066 79.7113 555.066 80.342L553.988 79.792C553.988 79.22 554.12 78.7213 554.384 78.296C554.648 77.8707 555.007 77.548 555.462 77.328C555.916 77.0933 556.415 76.976 556.958 76.976C556.972 76.976 556.987 76.976 557.002 76.976C557.031 76.976 557.053 76.976 557.068 76.976ZM553.724 88.592C554.765 88.592 555.579 88.834 556.166 89.318C556.752 89.7873 557.046 90.418 557.046 91.21C557.046 91.9287 556.804 92.552 556.32 93.08C555.85 93.608 555.212 94.0113 554.406 94.29C553.614 94.5833 552.719 94.73 551.722 94.73C549.991 94.73 548.693 94.4367 547.828 93.85C546.977 93.2633 546.552 92.5593 546.552 91.738C546.552 91.1513 546.742 90.6233 547.124 90.154C547.52 89.6993 548.18 89.4427 549.104 89.384L548.95 89.714C548.451 89.582 548.026 89.362 547.674 89.054C547.336 88.7313 547.168 88.2693 547.168 87.668C547.168 87.0667 547.388 86.5533 547.828 86.128C548.282 85.688 548.95 85.4167 549.83 85.314L550.996 85.908H550.776C550.057 85.9813 549.544 86.1647 549.236 86.458C548.942 86.7367 548.796 87.0447 548.796 87.382C548.796 87.7927 548.942 88.1007 549.236 88.306C549.544 88.4967 549.969 88.592 550.512 88.592H553.724ZM551.7 93.256C552.55 93.256 553.247 93.168 553.79 92.992C554.347 92.816 554.758 92.5887 555.022 92.31C555.286 92.0313 555.418 91.7307 555.418 91.408C555.418 91.012 555.256 90.6967 554.934 90.462C554.626 90.2273 554.061 90.11 553.24 90.11H549.852C549.382 90.11 548.986 90.2273 548.664 90.462C548.341 90.7113 548.18 91.0487 548.18 91.474C548.18 92.0167 548.488 92.4493 549.104 92.772C549.734 93.0947 550.6 93.256 551.7 93.256ZM551.546 78.78C552.426 78.78 553.203 78.9413 553.878 79.264C554.567 79.572 555.102 80.0047 555.484 80.562C555.865 81.1193 556.056 81.7647 556.056 82.498C556.056 83.2167 555.865 83.862 555.484 84.434C555.102 84.9913 554.567 85.4313 553.878 85.754C553.203 86.062 552.426 86.216 551.546 86.216C550.094 86.216 548.979 85.8713 548.202 85.182C547.424 84.478 547.036 83.5833 547.036 82.498C547.036 81.7647 547.226 81.1193 547.608 80.562C548.004 80.0047 548.539 79.572 549.214 79.264C549.888 78.9413 550.666 78.78 551.546 78.78ZM551.546 80.21C550.783 80.21 550.145 80.4227 549.632 80.848C549.118 81.2587 548.862 81.8087 548.862 82.498C548.862 83.1727 549.118 83.7227 549.632 84.148C550.145 84.5733 550.783 84.786 551.546 84.786C552.308 84.786 552.946 84.5733 553.46 84.148C553.973 83.7227 554.23 83.1727 554.23 82.498C554.23 81.8087 553.973 81.2587 553.46 80.848C552.946 80.4227 552.308 80.21 551.546 80.21ZM560.395 87.36C560.82 87.36 561.165 87.492 561.429 87.756C561.693 88.02 561.825 88.3647 561.825 88.79C561.825 89.2153 561.693 89.56 561.429 89.824C561.165 90.088 560.82 90.22 560.395 90.22C559.969 90.22 559.625 90.088 559.361 89.824C559.097 89.56 558.965 89.2153 558.965 88.79C558.965 88.3647 559.097 88.02 559.361 87.756C559.625 87.492 559.969 87.36 560.395 87.36ZM566.239 87.36C566.664 87.36 567.009 87.492 567.273 87.756C567.537 88.02 567.669 88.3647 567.669 88.79C567.669 89.2153 567.537 89.56 567.273 89.824C567.009 90.088 566.664 90.22 566.239 90.22C565.813 90.22 565.469 90.088 565.205 89.824C564.941 89.56 564.809 89.2153 564.809 88.79C564.809 88.3647 564.941 88.02 565.205 87.756C565.469 87.492 565.813 87.36 566.239 87.36ZM572.082 87.36C572.508 87.36 572.852 87.492 573.116 87.756C573.38 88.02 573.512 88.3647 573.512 88.79C573.512 89.2153 573.38 89.56 573.116 89.824C572.852 90.088 572.508 90.22 572.082 90.22C571.657 90.22 571.312 90.088 571.048 89.824C570.784 89.56 570.652 89.2153 570.652 88.79C570.652 88.3647 570.784 88.02 571.048 87.756C571.312 87.492 571.657 87.36 572.082 87.36Z",
    fill: "#AAAAAA"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3526_3480",
    x1: 8,
    y1: 14,
    x2: 48,
    y2: 14,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3526_3480",
    x1: 8,
    y1: 39,
    x2: 48,
    y2: 39,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_3526_3480",
    x1: 8,
    y1: 70,
    x2: 48,
    y2: 70,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_3526_3480",
    x1: 8,
    y1: 99,
    x2: 48,
    y2: 99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_3526_3480",
    x1: 8,
    y1: 130,
    x2: 48,
    y2: 130,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_3526_3480",
    x1: 8,
    y1: 159,
    x2: 48,
    y2: 159,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_3526_3480",
    x1: 56,
    y1: 175,
    x2: 1030,
    y2: 175,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F1F1F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChartLoading);
export default __webpack_public_path__ + "static/media/chart_loading.fefa8594.svg";
export { ForwardRef as ReactComponent };